import React, { useState, useCallback, useRef } from "react";
import { connect } from "react-redux";
import AccordionReact from 'devextreme-react/accordion';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';
import FormField from '../../../dynamicFormBuilder/FormField';
import LocationMasterFormLayout from './LocationMasterFormLayout';
import { GetLookupStaticData } from "../../../om/services/SalesOrderService";
import { status as LocationStatuses, locationTypes } from "../../../const/Lookup";

// Shared {key,value} lists → the {ID, Text} shape GetLookupStaticData expects.
const toOptions = (list) => list.map((x) => ({ ID: x.key, Text: x.value }));

const searchpanel = [{ ID: 1, Title: 'Search Filters' }];

const buildInitialFields = () => ({
  IdentityId: '', LocationCode: '', Description: '', Status: '',
  ClassCode: '', SubClassCode: '', LocationType: '', Priority: '',
});

// Location Master search panel — dynamic FormField from LocationMasterFormLayout. Same pattern as the Item
// Master / Item/Lot search panels; feeds the GetLocations endpoint (LocationDto filter).
const LocationMasterFilters = (props) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [forceRender, setForceRender] = useState(false);
  const [formFields, setformFields] = useState(buildInitialFields());
  const formRefs = useRef({});

  const selectionChanged = useCallback((e) => {
    let newItems = [...selectedItems];
    e.removedItems.forEach((item) => { const idx = newItems.indexOf(item); if (idx >= 0) newItems.splice(idx, 1); });
    if (e.addedItems.length) newItems = [...newItems, ...e.addedItems];
    setSelectedItems(newItems);
  }, [selectedItems]);

  const handleFormSubmit = () => { props.searchData(formFields); };
  const handleReset = () => { setformFields(buildInitialFields()); };
  const handleFieldChange = useCallback(() => {}, []);

  // Status / Location Type are coded fields — load descriptive dropdown options (shared const/Lookup lists).
  const handleFormLoad = useCallback(() => {
    GetLookupStaticData("Status", toOptions(LocationStatuses), formRefs, setForceRender, forceRender);
    GetLookupStaticData("LocationType", toOptions(locationTypes), formRefs, setForceRender, forceRender);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AccordionReact
      dataSource={searchpanel}
      collapsible={true}
      multiple={false}
      animationDuration={300}
      selectedItems={selectedItems}
      onSelectionChanged={(e) => { if (e.currentTarget === e.target) selectionChanged(e); }}
      itemTitleRender={() => (
        <Toolbar className="accordian-toolbar">
          <Item location="before">
            <div className="title">
              <h6 style={{ color: window._env_.Color2 }}>{'IM Item Management (Location Master)'}</h6>
            </div>
          </Item>
          <Item location="after">
            <Button className="accordianButton" onClick={handleFormSubmit} text="Search" type="default" />
          </Item>
          <Item location="after">
            <Button className="accordianButton" onClick={handleReset} text="Reset" />
          </Item>
        </Toolbar>
      )}
      itemRender={() => (
        <div>
          <FormField
            currrentUser={props.currentUser}
            layoutId='0046d046-2f34-4b56-9a21-0046aabbcc20'
            layoutName='ItemManagementLocationMaster'
            defaultFormSchema={LocationMasterFormLayout}
            formFields={formFields}
            setformFields={setformFields}
            handleFieldValueChange={handleFieldChange}
            DYNAMICFORMSETTING={props.DYNAMICFORMSETTING}
            formRefs={formRefs}
            onFormLoad={handleFormLoad}
            noSpacingBeforeFirstRow={true}
          />
        </div>
      )}
      id="accordion-container" className="accordion-height"
    />
  );
};

function mapStateToProps(state) { return { oidc: state.oidc }; }
export default connect(mapStateToProps)(LocationMasterFilters);
